export default __webpack_public_path__ + "static/media/lc.cb052707.svg";